import { Injectable } from '@angular/core';
import { Event, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { HttpClient } from '@angular/common/http';
import { ThemeService } from './theme.service';
import { catchError, map } from 'rxjs/operators';
import { EnvConfig } from '../models/env-config';
import * as jsyaml from 'js-yaml';
// @ts-ignore
import { default as j } from '../../../package-lock.json';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(
    private router: Router,
    private themeService: ThemeService,
    private localStorageService: SessionStorageService,
    private http: HttpClient
  ) {
    this.router.events.subscribe((e: Event) => {});

    console.log('version: ', j.version);
  }

  private _recaptchaSiteKeyV3: string | null = null;

  public get recaptchaSiteKeyV3(): string {
    return this._recaptchaSiteKeyV3 || '';
  }

  public async loadConfig(): Promise<EnvConfig> {
    return new Promise(async (resolve, reject) => {
      const currentEnvConfig = this.localStorageService.getEnvConfig();

      const urlPieces = window.location.href.match(/\/\w+/g);
  
      if(urlPieces && urlPieces.length > 1 && currentEnvConfig.productId) {
        resolve(currentEnvConfig);
        return;
      }

      const urlSearchParams = new URLSearchParams(window.location.search);
      const paramProductId: string | null = urlSearchParams.get('productId');
      const paramOrigemComercialId = urlSearchParams.get('sourceId');
      const paramTheme = urlSearchParams.get('theme');
      const paramUrlStart = urlSearchParams.get('start');
      const tokenIndicacao = urlSearchParams.get('memberCode');
      
      const emissor = paramTheme || this.themeService.getThemeFromUrl();

      if (emissor) {
        let envConfig: EnvConfig = paramProductId ? await this.loadConfigFromFile(emissor, paramProductId) : await this.loadConfigFromFile(emissor);

        if (envConfig) {
          this._recaptchaSiteKeyV3 = envConfig.captchaKey || '';

          if(tokenIndicacao)
            envConfig.tokenIndicacao = tokenIndicacao;
          if (paramOrigemComercialId) 
            envConfig.origemComercialId = paramOrigemComercialId;
          if (paramProductId) 
            envConfig.productId = paramProductId;
          if (paramUrlStart === 'true' || paramUrlStart === '1') {
            envConfig.urlStart = true;
            envConfig.urlStartFromQuery = true;
          } else if (paramUrlStart === 'false' || paramUrlStart === '0') {
            envConfig.urlStart = false;
            envConfig.urlStartFromQuery = false;
          }
          this.localStorageService.saveEnvConfig(envConfig);
          resolve(envConfig);
        }
      }
    });
  }

  loadYamlConfigFile = (path: string, nomeArquivo: string) =>
    this.http.get(`assets/temas/${path}/${nomeArquivo}`, {
      observe: 'body',
      responseType: 'text',
    }).pipe(
      catchError(err => {
        if(nomeArquivo.match(/\w+-\w+-\d+\.yml/g)){
          return  this.http.get(`assets/temas/${path}/config.yml`, {
            observe: 'body',
            responseType: 'text',
          });
        }
        throw 'Erro ao buscar arquivo. ' + err;
      }));

  loadYamlS3ConfigFile = (path: string, nomeArquivo: string) =>
    this.http.get(`${environment.filesUrl}/assets/temas/${path}/${nomeArquivo}`, {
      observe: 'body',
      responseType: 'text',
    }).pipe(
      catchError(err => {
        if(nomeArquivo.match(/\w+-\w+-\d+\.yml/g)){
          return  this.http.get(`${environment.filesUrl}/assets/temas/${path}/config.yml`, {
            observe: 'body',
            responseType: 'text',
          });
        }
        throw 'Erro ao buscar arquivo. ' + err;
      }));

  async loadConfigFromFile(nomeEmissor: string, produto?: string): Promise<EnvConfig> {
    const forkJoinResult = await forkJoin([
      // this.loadYamlConfigFile('default'),
      environment.localAssets
        ? this.loadYamlConfigFile(nomeEmissor, `${produto ? 'config-productId-' + produto + '.yml' : 'config.yml'}`)
        : this.loadYamlS3ConfigFile(nomeEmissor, `${produto ? 'config-productId-' + produto + '.yml' : 'config.yml'}`),
    ])
      .pipe(
        map(
          (yamls) =>
          {
            return yamls
              .map((yaml: string) => jsyaml.load(yaml)) // converte de yaml para json
              .reduce((acc: any, val: any) => ({ ...acc, ...val }), {}) // merge config default + config do emissor
          }
        ),
        map((val) => val as EnvConfig)
      )
      .toPromise();
    return forkJoinResult;
  }
}
